import '@modules/select';

export const template = (context, html) => html`
  <aofl-select-list @change="${context.tabChanged}">
    <slot name="tab"></slot>
  </aofl-select-list>
`;
